import { GET_VERIFYS } from "./types"
import apiStore from "../store/ApiStore";

export const getVerifys = (page = 0, pagesize = 10, start = null, end = null, search = null, result = null, sortBy = null, sortDesc = null) => {
    return {
        type: GET_VERIFYS,
        items: apiStore.getVoiceVerifysAll(page < 0 ? 0 : page, pagesize, start, end, search, result, sortBy, sortDesc),
    }
}
